<div class="service-history-container w-full pt-11 pb-6"
  *ngIf="{serviceHistory: serviceHistory$ | async, filteredServiceHistory: filteredServiceHistory$ | async, openQuoteLines: openQuoteLines$ | async} as data">
  <div class="w-full flex flex-row items-center place-content-between" style="margin-bottom: 18px">
    <span class="text-base font-semibold pl-6" style="font-family: 'Open Sans'">Service History
      ({{data.filteredServiceHistory.length}})</span>
    <button mat-icon-button class="mr-1" (click)="toggleServiceHistoryCollapse(serviceHistoryUi)">
      <mat-icon>{{serviceHistoryUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
      </mat-icon>
    </button>
  </div>
  <div class="flex shadow-lg bg-white rounded-lg p-4 mr-1 w-full"
    *ngIf="!serviceHistoryUi.collapsed && data.serviceHistory?.length > 0; else noServiceHistory">
    <div class="w-full">
      <ng-container>
        <form class="flex flex-col" [formGroup]="filterForm">
          <mat-form-field appearance="outline" class="text-sm">
            <input id="serviceHistoryFilter" matInput type="text" formControlName="serviceHistoryFilter"
              placeholder="Search" autocomplete="off">
          </mat-form-field>
        </form>
        <div *ngIf="data.filteredServiceHistory?.length > 0; else noFilteredServiceHistory">
          <div *ngFor="let workOrder of data.filteredServiceHistory | orderBy: sort" fxLayout="column"
            style="width:100%;" class="result-container text-xs">
            <div fxLayoutAlign="space-between center" class="result-header-container">
              <div fxLayout="column">
                <span class="cursor-pointer font-semibold underline mb-2" style="color: #0054A6;">RO
                  {{workOrder.id}}</span>
                <div fxLayout="row" fxLayoutAlign="start center" style="color:rgb(82,82,82);">
                  <span>{{workOrder.dateIn | moment: 'MMM DD, YYYY'}} &bull;
                    {{workOrder.odometerIn | number | unitOfMeasure | async}}
                  </span>
                </div>
                <!-- <div fxLayout="row" fxLayoutAlign="start center" style="color:rgb(82,82,82);"
                  [ngSwitch]="workOrder.statusId">
                  <span *ngSwitchCase="0">Posted</span>
                  <span *ngSwitchCase="1">Open</span>
                  <span *ngSwitchCase="2">Assigned</span>
                  <span *ngSwitchCase="'A'">Appointment</span>
                  <span *ngSwitchCase="'C'">Completed</span>
                  <span *ngSwitchCase="'I'">In-Progress</span>
                  <span *ngSwitchCase="'P'">PDI</span>
                  <span *ngSwitchCase="'Q'">Quote</span>
                </div> -->
              </div>
            </div>
            <mat-divider *ngIf="workOrder.embedded.cases.length > 0"></mat-divider>
            <div *ngIf="workOrder.embedded.cases.length > 0" class="result-content-container">
              <div *ngFor="let case of workOrder.embedded.cases | orderBy: 'sequence' ; let i = index; let last = last;"
                [ngClass]="{ 'pb-5': !last }">
                <div class="w-full flex flex-row text-black">
                  <div class="w-2/3">
                    <span class="font-semibold">{{case.sequence}}. {{case.labourOp ?
                      case.labourOp + ' - ' : ''}}</span>
                    <span *ngIf="case.note" class="font-light" #showMoreToggle>
                      <span>{{!showMoreToggle.value && case.note?.length > caseNoteMaxLength ? (case.note |
                        slice:0:caseNoteMaxLength) + '...' :
                        (case.note)}}</span>
                      <span class="underline ml-1 whitespace-nowrap cursor-pointer" style="color: #0054A6;"
                        (click)="showMoreToggle.value = !showMoreToggle.value">
                        <span *ngIf="!showMoreToggle.value && case.note?.length > caseNoteMaxLength">See more</span>
                        <span *ngIf="showMoreToggle.value && case.note?.length > caseNoteMaxLength">See less</span>
                      </span>
                    </span>
                  </div>
                  <div class="w-1/3 ml-6 text-right">
                    <span class="font-semibold">{{case.warrantySubmissionTypeId}}</span>
                    &bull;
                    <span class="font-light">{{case.technicianGroupName?.split('-')[0]}}</span>
                    <!-- <div fxLayoutAlign="start start">
                      <span class="primary-bullet">·</span>
                      <span class="mat-caption">Cause: {{case.cause}}</span>
                    </div>
                    <div fxLayoutAlign="start start">
                      <span class="primary-bullet">·</span>
                      <span class="mat-caption">Correction: {{case.technicianStory}}</span>
                    </div> -->
                  </div>
                </div>
              </div>

              <!-- <div fxLayout="column" *ngIf="workOrder.embedded.declinedMpviCodes.length > 0">
                <h3 style="margin-bottom: 4px;font-weight:500;">Declined Operations</h3>
                <div fxLayout="column" style="width:100%;">
                  <div fxLayout="row" fxLayoutAlign="start start"
                    *ngFor="let declinedOperation of workOrder.embedded.declinedMpviCodes | filterBy: ['classificationId']: 1 | orderBy: 'sequence';let i = index;"
                    style="padding-bottom:20px;" data-cy='declined-operation'>
                    <div class="test-container" style="background-color:#FFCDD2;border-color:#EF5350"
                      fxLayoutAlign="center center">
                      <span class="test-content">{{declinedOperation.sequence}}</span>
                    </div>
                    <div fxLayout="column" fxFlex>
                      <div fxLayoutAlign="start start">
                        <a class="mat-body-2">
                          {{declinedOperation.opCode}} {{declinedOperation?.embedded?.serviceGroup?.name}}
                        </a>
                      </div>
                      <div fxLayout="column">
                        <div fxLayout="column" style="color:rgb(82,82,82);">
                          <div fxLayoutAlign="start start">
                            <span class="primary-bullet">·</span>
                            <span class="mat-caption">
                              {{declinedOperation.associatedCase ? 'Associated with case #' +
                              declinedOperation.associatedCase + ' above' : 'Not associated with a case'}}
                            </span>
                          </div>
                          <div fxLayoutAlign="start start">
                            <span class="primary-bullet">·</span>
                            <span class="mat-caption">
                              {{declinedOperation.embedded && declinedOperation?.embedded?.declinedReason?.reason ? 'Service
                              was declined due to ' + declinedOperation?.embedded?.declinedReason?.reason : 'Reason declined
                              is
                              unknown'}}
                            </span>
                          </div>
                          <div fxLayoutAlign="start start">
                            <span class="primary-bullet">·</span>
                            <span class="mat-caption">{{declinedOperation.comments ? declinedOperation.comments : 'No
                              comments were made'}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div fxLayout="column" *ngIf="filteredOpenQuoteLinesByWorkOrder(workOrder.id) | async as filteredQuotes">
                <div *ngIf="filteredQuotes.length>0">
                  <h3 class="mb-1 font-medium">Open Quotes</h3>
                  <div fxLayout="column" style="width:100%;">
                    <div *ngFor="let line of filteredQuotes; let i = index" fxLayout="row" fxLayoutAlign="start start"
                      class="pb-5">
                      <div fxLayout="column" fxFlex>
                        <a class="mat-body-2">
                          {{i+1}}. {{line.serviceName}}
                        </a>
                        <div fxLayout="column">
                          <div fxLayout="column" style="color:rgb(82,82,82);">
                            <div fxLayoutAlign="start start">
                              <span class="primary-bullet">·</span>
                              <span class="mat-caption">
                                {{line.warrantySubmissionTypeId}} recommended at
                                {{line.recommendedHours ? line.recommendedHours : '0'}} hours quoted by
                                {{line?.embedded?.employeeAssociate?.firstName + ' ' +
                                line?.embedded?.employeeAssociate?.lastName}}
                              </span>
                            </div>
                            <div fxLayoutAlign="start start">
                              <span class="primary-bullet">·</span>
                              <span class="mat-caption">
                                The quote for {{line.totalAmount | currency}} Expires on
                                {{line.expirationDate | moment: 'MMM DD, YYYY'}} </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <!-- <div fxLayout="column" *ngIf="unlinkedQuoteLinesArr$ | async as unlinkedQuotes" class="mt-2">
            <div *ngIf="unlinkedQuotes.length>0">
              <h2 class="mb-2 font-medium">Other Open Quotes</h2>
              <div fxLayout="column" style="width:100%;" class="result-container pl-6 pt-4">
                <div *ngFor="let line of unlinkedQuotes; let i = index" fxLayout="row" fxLayoutAlign="start start"
                  class="pb-5">
                  <div fxLayout="column" fxFlex>
                    <a class="mat-body-2">
                      {{i+1}}. {{line.serviceName}}
                    </a>
                    <div fxLayout="column">
                      <div fxLayout="column" style="color:rgb(82,82,82);">
                        <div fxLayoutAlign="start start">
                          <span class="primary-bullet">·</span>
                          <span class="mat-caption">
                            {{line.warrantySubmissionTypeId}} recommended at
                            {{line.recommendedHours ? line.recommendedHours : '0'}} hours quoted by
                            {{line?.embedded?.employeeAssociate?.firstName + ' ' +
                            line?.embedded?.employeeAssociate?.lastName}}
                          </span>
                        </div>
                        <div fxLayoutAlign="start start">
                          <span class="primary-bullet">·</span>
                          <span class="mat-caption">
                            The quote for {{line.totalAmount | currency}} Expires on
                            {{line.expirationDate | moment: 'MMM DD, YYYY'}} </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <ng-template #noFilteredServiceHistory>
          <span class="text-base font-semibold w-full flex justify-center"
            style="font-family: 'Open Sans'; color: #555;">
            No results found.
          </span>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <ng-template #noServiceHistory>
    <div *ngIf="!serviceHistoryUi.collapsed"
      class="flex shadow-lg bg-white rounded-lg p-4 mr-1 w-full h-20 items-center">
      <span class="text-base font-semibold" style="font-family: 'Open Sans'; color: #555;">
        No service history for this vehicle.
      </span>
    </div>
  </ng-template>
</div>